module.exports = __webpack_public_path__ + "multi-lang-arrow-down.svg?f692c045933abdf4185f730d203d893d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/multi-lang-arrow-down.svg
// module id = 235
// module chunks = 0